import React from "react";
import type { IconProps } from "./icon.types";

export function ClockCircle({ size = 24, ...props }: IconProps): React.ReactElement {
  return (
    <svg
      {...props}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M19 12a7 7 0 1 1-14 0a7 7 0 0 1 14 0Z" />
      <path d="M12 8v4l3 3" />
    </svg>
  );
}
